import { Component, input } from '@angular/core';

@Component({
    selector: 'message-date-divider',
    templateUrl: './message-date-divider.component.html',
    standalone: false
})
export class MessageDateDividerComponent {
    public date = input<Date>(null);
}
